import { Component, createElement } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

const mapStateToProps = ({ 
  Root: { langKey }
}) => ({
  langKey
});

class T extends Component {
  constructor(props) {
    super(props);

    this.localeListener = (locale) => this.setState({ locale: locale });
  }
  componentDidMount() {
    if (this.context.translate.addListener) {
      this.context.translate.addListener("localeChanged", this.localeListener);
    }
  }
  componentWillUnmount() {
    if (this.context.translate.removeListener) {
      this.context.translate.removeListener(
        "localeChanged",
        this.localeListener
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.langKey !== this.props.langKey) {
      var props = { ...this.props };
      createElement(
        this.props.component || "span",
        props,
        this.context.translate.translate(this.props.children, this.props)
      )
    }
  }

  render() {
    var props = { ...this.props };

    delete props.component;

    return createElement(
      this.props.component || "span",
      props,
      this.context.translate.translate(this.props.children, this.props)
    );
  }
}

T.propTypes = {
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.Element]),
  children: PropTypes.string.isRequired,
};

T.contextTypes = {
  translate: PropTypes.shape({
    translate: PropTypes.func.isRequired,
    addListener: PropTypes.func,
    removeListener: PropTypes.func,
  }).isRequired,
};

export default connect(mapStateToProps)(T);
